export const tableOptions = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: '勋章预览',
    prop: 'name',
    overHidden: true,
    solt: true,
    align: 'left',
    width: 240,
  },{
    label: '等级',
    prop: 'grade',
    sortable: true,
    width: 100,
  },{
    label: '等级名称',
    prop: 'gradeName',
    width: 120,
  },{
    label: '勋章规则',
    prop: 'medalRule',
    width: 160,
  },{
    label: '勋章分组',
    prop: 'groupName',
    width: 160,
  },{
    label: '获取条件',
    prop: 'condition',
    width: 100,
  },{
    label: '是否启用',
    prop: 'isActive',
    width: 100,
    type: 'Select',
    dicData: [{
      label: '已启用',
      value: true
    }, {
      label: '已禁用',
      value: false
    }]
  }]
}

export const medalRules = [
  { label: '限定勋章', value: 1 },
  { label: '用户累计签到天数', value: 2 },
  { label: '累计发帖数', value: 3 },
  { label: '累计评论数', value: 4 },
  { label: '全部帖子累计获赞数', value: 5 },
  { label: '单个帖子累计获赞数', value: 6 },
  { label: '全部帖子累计被收藏数', value: 7 },
  { label: '单个帖子累计被收藏数', value: 8 },
  { label: '用户粉丝数', value: 9 },
  { label: '累计积分', value: 10 },
  { label: '工作年限（天）', value: 11 },
  { label: '累计领导点赞助力数', value: 12 },
]